export const buildAdminAppResult = <
  TAuth extends object,
  TNavigation extends object,
  TSlides extends object,
  TPages extends object,
  TBuilder extends object,
  TProfile extends object,
  TSecurity extends object,
>({
  apiBase,
  auth,
  navigation,
  slides,
  pages,
  builder,
  profile,
  security,
}: {
  apiBase: string
  auth: TAuth
  navigation: TNavigation
  slides: TSlides
  pages: TPages
  builder: TBuilder
  profile: TProfile
  security: TSecurity
}): {
  API_BASE: string
} & TAuth &
  TNavigation &
  TSlides &
  TPages &
  TBuilder &
  TProfile &
  TSecurity => ({
  API_BASE: apiBase,
  ...auth,
  ...navigation,
  ...slides,
  ...pages,
  ...builder,
  ...profile,
  ...security,
})
